// This file was auto-generated. Do not hand edit.
angular.module('tmr').service('VehicleData', function() {
    var self = this;

    var carTypes = {
        "ALFA ROMEO" : [
            "147",
            "156",
            "159",
            "BRERA",
            "GIULIA",
            "GIULIETTA",
            "GTV SERIES",
            "GT SERIES",
            "MITO",
            "ROMEO",
            "SPIDER"
        ],
        "AUDI" : [
            "80",
            "A1",
            "A3",
            "A4",
            "A4 AVANT",
            "A4-B7",
            "A5",
            "A6",
            "A6-C5",
            "A6-C6",
            "A6-C7",
            "A7",
            "A8",
            "ALLROAD",
            "Q2",
            "Q3",
            "Q5",
            "Q7",
            "R8",
            "RS4",
            "RS5",
            "S3",
            "S4",
            "S5",
            "SQ5 3.0L",
            "TT"
        ],
        "BMW" : [
            "116I",
            "118D",
            "118I",
            "120D",
            "120I",
            "123D",
            "125I",
            "130I",
            "135I",
            "218i",
            "220I",
            "316I",
            "316TI",
            "318D",
            "318I",
            "318IS",
            "318TI",
            "320CI",
            "320D",
            "320I",
            "323CI",
            "323I",
            "325CI",
            "325E",
            "325I",
            "328I",
            "330CI",
            "330D",
            "330I",
            "335CI",
            "335I",
            "420D",
            "420I",
            "428I",
            "435I",
            "520",
            "520D",
            "520I",
            "523I",
            "525I",
            "528I",
            "530D",
            "530I",
            "535D",
            "535I",
            "540I",
            "545I",
            "635CSI",
            "640I",
            "650I",
            "730D",
            "735I",
            "735IL",
            "740I",
            "740IL",
            "M3",
            "M5",
            "M6",
            "M135I",
            "M COUPE",
            "X1",
            "X3",
            "X5",
            "X6",
            "Z3",
            "Z4"
        ],
        "BYD" : [
            "ATTO 3"
        ],
        "CADILLAC" : [
            "ESCALADE"
        ],
        "CHERY" : [
            "J1",
            "J3",
            "J11",
            "OMODA 5"
        ],
        "CHEVROLET" : [
            "210 SERIES",
            "BEL AIR",
            "BLAZER",
            "CAMARO",
            "CHEVELLE",
            "CORVETTE",
            "IMPALA",
            "NOVA"
        ],
        "CHRYSLER" : [
            "300",
            "300C",
            "300S",
            "CHARGER",
            "CROSSFIRE",
            "GRAND VOYAGER",
            "JEE",
            "NEO",
            "NEON",
            "PT CRUISER",
            "SEBRING",
            "VAL",
            "VALIANT",
            "VOY",
            "VOYAGER"
        ],
        "CITROEN" : [
            "BERLINGO",
            "C2",
            "C3",
            "C4",
            "C5",
            "DS3",
            "DS4",
            "PICASSO",
            "XANTIA 2.0 I",
            "XSARA"
        ],
        "CORVETTE" : [
            "C4"
        ],
        "DAEWOO" : [
            "1.5I",
            "CIELO",
            "ESPERO",
            "KALOS",
            "LACETTI",
            "LANOS",
            "LEGANZA",
            "MATIZ",
            "NUBIRA",
            "TACUMA"
        ],
        "DAIHATSU" : [
            "APPLAUSE",
            "CHARADE",
            "COPEN",
            "CUORE",
            "FEROZA",
            "MIRA",
            "PYZAR",
            "ROCKY 4X4",
            "SIRION",
            "TERIOS",
            "YRV"
        ],
        "DATSUN" : [
            "120Y",
            "240Z",
            "260Z",
            "1200",
            "1600"
        ],
        "DODGE" : [
            "AVENGER",
            "CALIBER",
            "CHALLENGER",
            "CHARGER",
            "JOURNEY",
            "NITRO",
            "PHOENIX",
            "RAM"
        ],
        "FIAT" : [
            "124",
            "500C",
            "500 SERIES",
            "DUCATO",
            "FREEMONT",
            "PUNTO",
            "RITMO",
            "SCUDO",
            "SPIDER"
        ],
        "FORD" : [
            "ANGLIA",
            "AU",
            "BRONCO",
            "CAPRI",
            "CORSAIR",
            "CORTINA",
            "COUGAR",
            "COURIER",
            "CUSTOMLINE",
            "DELUX",
            "ECONOVA",
            "ECONOVAN",
            "ECOSPORT",
            "EL",
            "ENDURA",
            "ESCAPE",
            "ESCORT",
            "EVEREST",
            "EXPLORER",
            "F100",
            "F150",
            "F250",
            "FAIRLANE",
            "FAIRMONT",
            "FALCON",
            "FESTIVA",
            "FIESTA",
            "FOCUS",
            "FORTE",
            "FUTURA",
            "GALAXY",
            "JEEP",
            "KA SERIES",
            "KUGA",
            "LASER",
            "LTD",
            "MAVERICK",
            "MERCURY",
            "METEOR",
            "MODEL A",
            "MODEL T",
            "MONDEO",
            "MUSTANG",
            "PROBE",
            "PUMA",
            "RAIDER",
            "RANGER",
            "ROADSTER",
            "TAURUS",
            "TAURUS GHIA",
            "TELSTAR",
            "TERRITORY",
            "THUNDERBIRD",
            "TRANSIT",
            "TUDOR",
            "T BUCKET",
            "ZEPHYR"
        ],
        "FOTON" : [
            "TUNLAND"
        ],
        "GENESIS" : [
            "GV70"
        ],
        "GREAT WALL" : [
            "CANNON",
            "TANK 300",
            "V240",
            "X200",
            "X240"
        ],
        "HAVAL" : [
            "H2",
            "H6",
            "H9",
            "JOLION"
        ],
        "HILLMAN" : [
            "GAZELLE"
        ],
        "HOLDEN" : [
            "ACADIA",
            "ACCLA",
            "ADVENTRA",
            "APOLLO",
            "ASTRA",
            "BARINA",
            "BERLINA",
            "CALAIS",
            "CAMIRA",
            "CAPRI",
            "CAPRICE",
            "CAPTIVA",
            "CLUBSPORT",
            "COLORADO",
            "COMBO",
            "COMMODORE",
            "CREWMAN",
            "CRUZE",
            "EH",
            "EH SERIES",
            "EJ SERIES",
            "EK SERIES",
            "EPICA",
            "EQUINOX",
            "EXEC",
            "FB SERIES",
            "FC SERIES",
            "FJ SERIES",
            "FRONTERA",
            "FX SERIES",
            "GEMINI",
            "GRANGE",
            "GTS",
            "HD SERIES",
            "HG SERIES",
            "HJ SERIES",
            "HK SERIES",
            "HQ SERIES",
            "HR SERIES",
            "HSV",
            "HT SERIES",
            "HX SERIES",
            "HZ SERIES",
            "JACKAROO",
            "KINGSWOOD",
            "MALIBU",
            "MONARO",
            "NOVA",
            "RODEO",
            "SENATOR",
            "SPARK",
            "STATESMAN",
            "SUBURBAN",
            "TIGRA",
            "TORANA",
            "TRAILBLAZER",
            "TRAX",
            "VECTRA",
            "VIVA",
            "VT8VK",
            "XU6",
            "ZAFIRA"
        ],
        "HONDA" : [
            "ACCORD",
            "CITY",
            "CIVIC",
            "CONCERTO",
            "CRX",
            "CR-V",
            "CR-Z",
            "HR-V",
            "INSIGHT",
            "INTEGRA",
            "JAZZ",
            "LEGEND",
            "MDX",
            "ODYSSEY",
            "PRELUDE",
            "S2000"
        ],
        "HUMMER" : [
            "H3"
        ],
        "HYUNDAI" : [
            "ACCENT",
            "COUPE",
            "ELANTRA",
            "EXCEL",
            "GETZ",
            "GRANDEUR",
            "GX",
            "I20",
            "I30",
            "I30CW",
            "I40",
            "I45",
            "ILOAD",
            "IMAX",
            "IONIQ",
            "IX35",
            "KONA",
            "LANTRA",
            "LAVITA",
            "LX",
            "SANTA FE",
            "SONATA",
            "SPRI",
            "STARIA",
            "S COUPE",
            "TERRACAN",
            "TIBURON",
            "TRAJET",
            "TUCSON",
            "VELOSTER",
            "VENUE"
        ],
        "INFINITI" : [
            "Q50"
        ],
        "ISUZU" : [
            "D-MAX",
            "MU",
            "MU-X"
        ],
        "JAGUAR" : [
            "E TYPE",
            "F-PACE",
            "MK II PRE 1970",
            "SOVEREIGN",
            "S TYPE",
            "XE",
            "XF",
            "XJ",
            "XJ6",
            "XJ8",
            "XJS",
            "XJ/SOVEREIGN",
            "XK-8 & XKR",
            "X TYPE"
        ],
        "JEEP" : [
            "CHEROKEE",
            "COMMANDER",
            "COMPASS",
            "GRANDE LAREDO",
            "GRAND CHEROKEE",
            "LAREDO",
            "PATRIOT",
            "RENEGADE",
            "WRANGLER"
        ],
        "KIA" : [
            "CARENS",
            "CARNIVAL",
            "CERATO",
            "CREDOS",
            "MAGENTIS",
            "MENTOR",
            "OPTIMA",
            "PICANTO",
            "PREGIO",
            "RIO",
            "RONDO",
            "SELTOS",
            "SHUMA",
            "SORENTO",
            "SOUL",
            "SPECTRA",
            "SPORTAGE",
            "STINGER",
            "STONIC"
        ],
        "LAMBORGHINI" : [
            "HURACAN"
        ],
        "LANDROVER" : [
            "DEFENDER",
            "DISCOVERY",
            "EVOQUE",
            "FREELANDER",
            "ONE TEN",
            "RANGE ROVER",
            "RANGE ROVER SPORT",
            "SERIES III"
        ],
        "LDV" : [
            "D90",
            "G10",
            "T60",
            "V80"
        ],
        "LEXUS" : [
            "CT200H",
            "ES300",
            "ES300H",
            "GS250",
            "GS300",
            "GS350",
            "GS430",
            "GS450",
            "IS200",
            "IS250",
            "IS300",
            "IS300H",
            "IS350",
            "ISF",
            "LC500",
            "LS400",
            "LS430",
            "LS460",
            "LX470",
            "LX570",
            "NX200",
            "NX300",
            "RX270",
            "RX330",
            "RX350",
            "RX400H",
            "RX450H",
            "SC430",
            "UX 300e"
        ],
        "LOTUS" : [
            "ELISE"
        ],
        "MAHINDRA" : [
            "PIKUP"
        ],
        "MASERATI" : [
            "GHIBLI"
        ],
        "MAZDA" : [
            "2",
            "3",
            "121",
            "323",
            "626",
            "808",
            "929",
            "ASTINA",
            "BRAVO",
            "BT-50",
            "CAPELLA",
            "CX-3",
            "CX-5",
            "CX-7",
            "CX-7A",
            "CX-8",
            "CX-9",
            "CX-9A",
            "CX-30",
            "E2000",
            "EUNOS",
            "MAZDA2",
            "MAZDA3",
            "MAZDA6",
            "METRO",
            "MPV",
            "MX5",
            "MX-5",
            "MX-6",
            "MX-30",
            "PREMACY",
            "PROTEG",
            "RX3",
            "RX7",
            "RX8",
            "TRIBUTE"
        ],
        "MERCEDES-BENZ" : [
            "180E",
            "190E",
            "190E/190D",
            "220",
            "230 SERIES",
            "250",
            "260E",
            "280",
            "300",
            "300E",
            "350",
            "380 SERIES",
            "420",
            "450",
            "500",
            "560",
            "A45",
            "A140",
            "A160",
            "A170",
            "A180",
            "A190",
            "A200",
            "A250 SPORT",
            "A-CLASS",
            "B180",
            "B200",
            "B250",
            "C63 AMG",
            "C180 SERIES",
            "C200 SERIES",
            "C220 SERIES",
            "C230 SERIES",
            "C240 SERIES",
            "C250",
            "C280",
            "C300",
            "C320",
            "C350",
            "CL180",
            "CL200",
            "CL500",
            "CLA45 AMG",
            "CLA200",
            "CLA SERIES",
            "CLC200",
            "CLC SERIES",
            "CLK280",
            "CLK SERIES",
            "CLS250",
            "CLS350",
            "CLS500",
            "E55",
            "E63",
            "E200",
            "E220",
            "E230",
            "E240",
            "E250",
            "E270",
            "E280",
            "E320",
            "E350",
            "E400",
            "E500",
            "GL320",
            "GL350",
            "GL500",
            "GLA200 CDI",
            "GL CLASS",
            "ML63",
            "ML250",
            "ML270",
            "ML280CDI",
            "ML300",
            "ML320",
            "ML320CDI",
            "ML350",
            "ML430",
            "ML500",
            "R320",
            "R350",
            "S320",
            "S350",
            "S430",
            "S500",
            "SL350",
            "SL500",
            "SLK200",
            "SLK250",
            "SLK350",
            "SLK SERIES",
            "SPRINTER",
            "VALENTE",
            "VIANO",
            "VITO"
        ],
        "MG" : [
            "B",
            "B SERIES",
            "F",
            "HS",
            "MG3",
            "MG4",
            "MGA",
            "MGB",
            "MIDGET",
            "TC",
            "TF",
            "ZS",
            "ZT"
        ],
        "MINI" : [
            "COOPER",
            "COOPER S",
            "COUNTRYMAN",
            "RAY"
        ],
        "MITSUBISHI" : [
            "380",
            "380SX",
            "ALTER",
            "ASX",
            "CHALLENGER",
            "COLT",
            "DELICA",
            "ECLIPSE",
            "EVOLUTION",
            "EXPRESS",
            "FTO",
            "GALANT",
            "GRANDIS",
            "GTO",
            "L300",
            "LANCER",
            "LEGNUM",
            "MAGNA",
            "MIRAGE",
            "NIMBUS",
            "OUTLANDER",
            "PAJERO",
            "RVR",
            "SIGMA",
            "STARWAGON",
            "TRITON",
            "VERADA"
        ],
        "MORRIS" : [
            "COOPER S MINI",
            "MINI",
            "MINOR"
        ],
        "NISSAN" : [
            "180 SX",
            "200SX",
            "300ZX",
            "350Z",
            "370Z",
            "ALMERA",
            "ALTIMA",
            "BLUEBIRD",
            "CUBE",
            "DUALIS",
            "ELGRAND",
            "EXA COUPE",
            "GT-R",
            "JUKE",
            "LEAF",
            "MAXIMA",
            "MICRA",
            "MURANO",
            "NAVARA",
            "NOMAD",
            "NX/NX-R",
            "PATHFINDER",
            "PATROL",
            "PINTARA",
            "PULSAR",
            "QASHQAI",
            "SAFARI",
            "SILVIA",
            "SKYLINE",
            "STAGEA",
            "TERRANO",
            "TIIDA",
            "VECTO",
            "X-TRAIL",
            "Z50 MURANO"
        ],
        "PEUGEOT" : [
            "206",
            "207",
            "208",
            "306",
            "306X",
            "307",
            "308",
            "308 CC",
            "405",
            "406",
            "407",
            "505",
            "508",
            "2008 SERIES",
            "3008",
            "4007 SERIES",
            "4008",
            "EXPERT",
            "RCZ"
        ],
        "PONTIAC" : [
            "FIREBIRD"
        ],
        "PORSCHE" : [
            "911",
            "911 CARRERA",
            "911 CARRERA S",
            "928",
            "944",
            "BOXSTER",
            "CAYENNE",
            "CAYMAN",
            "MACAN",
            "PANAMERA"
        ],
        "PROTON" : [
            "GEN.2",
            "JUMBUCK",
            "PERSO",
            "PERSONA",
            "PREVE",
            "S16",
            "SATRI",
            "SATRIA",
            "SAVVY",
            "WAJA",
            "WIRA",
            "WIRA/PERSONA"
        ],
        "RENAULT" : [
            "ARKANA",
            "CAPTUR",
            "CLIO",
            "FLUENCE",
            "KANGOO",
            "KOLEOS",
            "LAGUNA",
            "LATITUDE",
            "MASTER",
            "MEGANE",
            "SCENIC",
            "TRAFIC"
        ],
        "ROLLS ROYCE" : [
            "SILVER SHADOW"
        ],
        "ROVER" : [
            "75 SERIES",
            "DISCOV",
            "MINI",
            "RANGE ROVER"
        ],
        "SAAB" : [
            "9-3",
            "9-5",
            "900",
            "900S",
            "9000"
        ],
        "SKODA" : [
            "FABIA",
            "KAROQ",
            "KODIAQ",
            "OCTAVIA",
            "RAPID",
            "ROOMSTER",
            "SUPERB",
            "YETI"
        ],
        "SSANGYONG" : [
            "ACTYON",
            "KORANDO",
            "KYRON",
            "MUSSO",
            "REXTON",
            "STAVIC",
            "TIVOLI"
        ],
        "SUBARU" : [
            "BRUMBY",
            "BRZ",
            "FORESTER",
            "IMPREZA",
            "LEGACY",
            "LEONE",
            "LEVORG",
            "LIBERTY",
            "L SERIES WAGON",
            "OUTBACK",
            "SPORT",
            "TRIBECA",
            "WRX",
            "XV"
        ],
        "SUZUKI" : [
            "ALTO",
            "APV",
            "BALENO",
            "CELERIO",
            "CINO",
            "GRAND VITARA",
            "IGNIS",
            "JIMNY",
            "KIZASHI",
            "LIANA",
            "SIERRA 4WD",
            "SWIFT",
            "SX4",
            "S-CROSS",
            "VITARA",
            "XL7",
            "X-90"
        ],
        "TATA" : [
            "XENON"
        ],
        "TESLA" : [
            "MODEL 3",
            "MODEL S",
            "MODEL Y"
        ],
        "TOYOTA" : [
            "4 RUNNER",
            "86",
            "ARISTO",
            "AURION",
            "AVALON",
            "AVENSIS",
            "CALDINA",
            "CAMRY",
            "CELICA",
            "CELSIOR",
            "CHASER",
            "CHR",
            "COROLLA",
            "CORONA",
            "CRESSIDA",
            "CROWN",
            "CRUIS",
            "ECHO",
            "ESTIMA",
            "FJ CRUISER",
            "FORTUNER",
            "GRANVIA",
            "GTS-86",
            "GT-86",
            "GXL",
            "HIACE",
            "HILUX",
            "KLUGER",
            "LANDCRUISER",
            "LEXCEN",
            "LEXUS",
            "LITE",
            "LITEACE",
            "MR2",
            "PASEO",
            "PRADO",
            "PRIUS",
            "RAV",
            "RAV4",
            "RUKUS",
            "SECA",
            "SOARER",
            "SPACIA",
            "SPRINTER",
            "STARLET",
            "SUPRA",
            "SURF",
            "TARAGO",
            "TERCEL",
            "TOWNACE",
            "TROOP",
            "VIENTA",
            "WORKMATE",
            "YARIS"
        ],
        "TRIUMPH" : [
            "TR4A"
        ],
        "VOLKSWAGEN" : [
            "AMAROK",
            "BEETLE",
            "BORA",
            "CADDY",
            "CARAVELLE",
            "CC",
            "EOS",
            "GOLF",
            "JETTA",
            "KARMANN",
            "KOMBI-VAN",
            "MANX",
            "MULTIVAN",
            "PASSAT",
            "POLO",
            "SCIROCCO",
            "TIGUAN",
            "TOUAREG",
            "TRANSPORTER",
            "TYPE 3",
            "T-CROSS",
            "T-ROC",
            "UP"
        ],
        "VOLVO" : [
            "240GL",
            "240 SERIES",
            "244",
            "440",
            "740 SERIES",
            "850SE",
            "850 SERIES",
            "940",
            "940GL",
            "960",
            "C30",
            "C70",
            "CROSS COUNTRY",
            "S40",
            "S60",
            "S70",
            "S80",
            "V40",
            "V50",
            "V60",
            "V70",
            "XC40",
            "XC60",
            "XC70",
            "XC90"
        ],
        "WOLSELEY" : [
            "6680"
        ]
    };

    var bikeTypes = {
        "APRILIA" : [
            "MOJITO 50",
            "MOJITO 125",
            "PEGASO 650",
            "RS125",
            "RSV4",
            "RSV1000 MILLE",
            "SCARABEO 200",
            "SHIVER 750",
            "SPORT CITY 125",
            "SPORT CITY ONE 50",
            "SPORT CITY ONE 125",
            "SR50 FACTORY",
            "SR 50",
            "SR MOTARD 50",
            "TUONO"
        ],
        "BMW" : [
            "F650GS",
            "F650 FUNDURO",
            "F700GS",
            "F800",
            "F800GS",
            "G650GS",
            "K100",
            "K100R",
            "K1100 SERIES",
            "K1200",
            "K1200LT",
            "K1300",
            "K1600",
            "R60",
            "R65",
            "R75",
            "R80",
            "R80GS",
            "R100",
            "R100GS",
            "R100R",
            "R100RS",
            "R1100",
            "R1150",
            "R1200C",
            "R1200GS",
            "R1200GS ADVENTURE",
            "R1200R",
            "R1200RT",
            "S1000RR"
        ],
        "BOLWELL" : [
            "FIRENZE 300",
            "GTS 250",
            "GYPSY",
            "JOLIE",
            "MIO 50",
            "RED DEVIL 50",
            "RETRO",
            "SHARK",
            "VS125"
        ],
        "BUELL" : [
            "XB12R",
            "XB12S"
        ],
        "CAN-AM" : [
            "SPYDER"
        ],
        "CCM" : [
            "450"
        ],
        "DUCATI" : [
            "600M MONSTER",
            "696 MONSTER",
            "750SS",
            "848",
            "900M MONSTER",
            "900SS",
            "998",
            "1000SS",
            "1098S",
            "1198S",
            "1199 PANIGALE",
            "DIAVEL",
            "DIAVEL CARBON",
            "GT1000",
            "H7",
            "HYPERMOTARD",
            "M620IE",
            "M696",
            "MONSTER 659",
            "MONSTER 1100",
            "MS2R",
            "MS4",
            "MULTISTRADA 1200",
            "SPORT 1000",
            "ST2",
            "ST3",
            "ST4S",
            "STREETFIGHTER"
        ],
        "GAS GAS" : [
            "EC300"
        ],
        "HARLEY DAVIDSON" : [
            "FLD",
            "FLHR",
            "FLHRCI ROAD KING",
            "FLHRC ROAD KING",
            "FLHRS1 CUSTOM KING",
            "FLHTC",
            "FLHTCUI",
            "FLHTCUI ULTRA",
            "FLHTCU E/GLIDE U/C",
            "FLHTCU ULTRA CLASSIC",
            "FLHTK ELECTRA GLIDE",
            "FLHT E/GLIDE/STANDAR",
            "FLHXI STREETGLIDE",
            "FLHX STREET GLIDE",
            "FLH SERIES",
            "FLS",
            "FLSTC",
            "FLSTCI",
            "FLSTFB",
            "FLSTFI FAT BOY",
            "FLSTF FAT BOY",
            "FLSTN",
            "FLST HERITAGE S/TAIL",
            "FLST SOFT TAIL",
            "FL SERIES",
            "FL SERIES FATBOY",
            "FXCWC",
            "FXDB",
            "FXDBI",
            "FXDCI DYNA S/GLIDE",
            "FXDC DYNA CUSTOM",
            "FXDF DYNA FAT BOB",
            "FXDI DYNA SUPERGLIDE",
            "FXDL DYNA LOWRIDER",
            "FXDWG DYNA WIDEGLIDE",
            "FXDX SUPERGLIDE SPOR",
            "FXD DYNA",
            "FXD SUPERGLIDE",
            "FXE",
            "FXRS LOWRIDER",
            "FXR SUPER GLIDE",
            "FXS",
            "FXSB",
            "FXSBSE",
            "FXSB BREAKOUT",
            "FXST",
            "FXSTB",
            "FXSTBI NIGHT TRAIN",
            "FXSTC SOFTAIL CUSTOM",
            "FXSTD DEUCE",
            "FXSTI",
            "FXSTS SOFTTAIL",
            "FXSTS SPRINGER",
            "FXWG WIDE GLIDE",
            "FX SERIES",
            "SHOVEL",
            "SOFTAIL",
            "SPORTSTER",
            "VRSCA",
            "VRSCAW V-ROD",
            "VRSCDX NIGHT ROD SP",
            "VRSCD NIGHT ROD",
            "VRSCF",
            "WLA",
            "XL883",
            "XL883C",
            "XL883L",
            "XL1200",
            "XL1200C",
            "XL1200N",
            "XL1200X",
            "XLH883 SPORTSTER",
            "XLH1200",
            "XL SPORTSTER",
            "XR1200"
        ],
        "HONDA" : [
            "CA250",
            "CB125",
            "CB250",
            "CB400",
            "CB500F",
            "CB500X",
            "CB600",
            "CB600F",
            "CB750",
            "CB750 ROAD",
            "CB900F",
            "CB1100",
            "CB1300",
            "CBF250",
            "CBF1000",
            "CBR125R",
            "CBR250R",
            "CBR250RR",
            "CBR500R",
            "CBR500RA",
            "CBR600",
            "CBR600F",
            "CBR600RR",
            "CBR900",
            "CBR900RR",
            "CBR1000",
            "CBR1000F",
            "CBR1000RR",
            "CBR1100",
            "CBR1100XX",
            "CBX1000",
            "CHF50",
            "CRF230L",
            "CRF250L",
            "CRF250X",
            "CRF450X",
            "CT110",
            "CTX200",
            "CX500",
            "DIO",
            "GL1500",
            "GL1800",
            "LEAD 100",
            "NBC110",
            "NC700",
            "NES125",
            "NT650V DEAUVILLE",
            "NT700V",
            "NVS50",
            "NX650 DOMINATOR",
            "PCX125",
            "PCX150",
            "REBEL",
            "SH150",
            "SK50",
            "SL230",
            "ST1100",
            "ST1300",
            "VF750C/F",
            "VFR750",
            "VFR750F",
            "VFR800",
            "VFR800F",
            "VFR1200F",
            "VT250",
            "VT400C SHADOW",
            "VT400 CRUISER",
            "VT750",
            "VT750 SHADOW",
            "VT1100C",
            "VT1300CX",
            "VTR250",
            "VTR1000",
            "VTX1300",
            "VTX1800",
            "WW125EX2",
            "XL250",
            "XL650V TRANSALP",
            "XL1000V VARADERO",
            "XR250",
            "XR250L",
            "XR250R",
            "XR400",
            "XR400M",
            "XR400R",
            "XR600",
            "XR600R",
            "XR650L",
            "XR650R",
            "Z50"
        ],
        "HUSABERG" : [
            "FE350",
            "FE390",
            "FE450",
            "FE501",
            "FE570",
            "TE300"
        ],
        "HUSQVARNA" : [
            "TE250",
            "TE310",
            "TE449",
            "TE510",
            "TE511",
            "TE610",
            "TE 450",
            "WR300"
        ],
        "HYOSUNG" : [
            "GT250",
            "GT250R",
            "GT650",
            "GT650RL",
            "GV250",
            "GV650 AQUILA",
            "GV650-40",
            "SUPER CAB 50"
        ],
        "INDIAN" : [
            "ROADMASTER",
            "SCOUT"
        ],
        "KAWASAKI" : [
            "1000GTR",
            "ELIMINATOR 250",
            "ER-5",
            "ER-6F",
            "ER-6N",
            "ER-6NL",
            "EX300ADF",
            "EX-250",
            "GPX250",
            "GPX250R",
            "GPZ900R (ZX900R)",
            "GTR1400",
            "KL250",
            "KL650E",
            "KLE500",
            "KLR250",
            "KLR650",
            "KLX250",
            "KLX400R",
            "KLX450",
            "KLX450R",
            "KLX650R",
            "NINJA 250R",
            "NINJA 300",
            "NINJA 650L",
            "NINJA 650R",
            "NINJA 650RL",
            "NINJA 1000",
            "VERSYS",
            "VN800",
            "VN900 CLASSIC",
            "VN900 CUSTOM",
            "VN900 VULCAN",
            "VN1500",
            "VN1600",
            "VN1700",
            "VN2000 VULCAN",
            "W650",
            "W800",
            "Z750 J",
            "Z900",
            "Z1000",
            "ZEPHYR 550 (ZR550)",
            "ZEPHYR 750 (ZR750)",
            "ZR750",
            "ZR1000",
            "ZRX1200",
            "ZX10",
            "ZX14 NINJA",
            "ZX750 ROAD",
            "ZX1000",
            "ZX1000 NINJA",
            "ZX1400",
            "ZXR250",
            "ZXR750",
            "ZX-6R NINJA",
            "ZX-6R NINJA (ZX636)",
            "ZX-9R",
            "ZX-10R",
            "ZX-12R",
            "ZX-14R",
            "ZZ-R250",
            "ZZ-R600",
            "ZZ-R1100 (ZX1100C)",
            "ZZ-R1200 (ZX1200C)"
        ],
        "KEEWAY" : [
            "RUNNA"
        ],
        "KTM" : [
            "200EXC",
            "200 DUKE",
            "250EXC",
            "250EXC-F",
            "300EXC",
            "300EXC-E",
            "350EXC",
            "350 EXC-F",
            "390 DUKE",
            "400 EXC",
            "450 EXC",
            "450 EXC-R",
            "500EXC",
            "520 EXC",
            "525 EXC",
            "530EXC",
            "530 EXC-R",
            "625SXC",
            "640 ADVENTURE",
            "640 LC4",
            "690 DUKE",
            "690 ENDURO",
            "950 ADVENTURE",
            "990 ADVENTURE",
            "990 SUPERDUKE",
            "990 SUPERMOTO",
            "1190 ADVENTURE",
            "FREERIDE"
        ],
        "KYMCO MOTOR CYCLES" : [
            "AGILITY 50",
            "AGILITY 125",
            "BUG VIBE",
            "LIKE 50",
            "LIKE 125",
            "PEOPLE 150",
            "SC10AS",
            "SUPER 8 50",
            "SUPER 8 125",
            "YUP50 (VIVA)"
        ],
        "MOTO GUZZI" : [
            "1100 CALIFORNIA",
            "BREVA 750",
            "NEVADA 750",
            "V7"
        ],
        "PIAGGIO" : [
            "FLY 125",
            "FLY 150",
            "LIBERTY 150",
            "TYPHOON 50",
            "TYPHOON 125",
            "ZIP 50",
            "ZIP 100"
        ],
        "SACHS" : [
            "EXPRESS"
        ],
        "SANG YANG INDUSTRIES" : [
            "CLASSIC 125",
            "JET 4R NAKED",
            "JET X SPORT",
            "ORBIT",
            "RED DEVIL",
            "VS125",
            "VS150"
        ],
        "SUZUKI" : [
            "AN400",
            "AN650",
            "BOULEVARD",
            "DL65OA",
            "DL650",
            "DL1000",
            "DR250",
            "DR350",
            "DR650",
            "DRZ250",
            "DR-Z400",
            "DR-Z400E",
            "DR-Z400SM",
            "GN250",
            "GS500",
            "GS500E",
            "GS500F",
            "GS1000",
            "GSF250",
            "GSF1200 BANDIT",
            "GSF1200 SKI",
            "GSF1250",
            "GSF1250S",
            "GSF1250SA",
            "GSR600",
            "GSR750",
            "GSX250",
            "GSX650F",
            "GSX650FU",
            "GSX750",
            "GSX1100 ROAD",
            "GSX1250FA",
            "GSX1300BK",
            "GSX1300R",
            "GSX1400",
            "GSXR1100 ROAD",
            "GSXR1300",
            "GSX-R600",
            "GSX-R1000",
            "GSX-R 750",
            "GW250",
            "GZ250",
            "M109",
            "RGV250",
            "SFV650",
            "SFV650U",
            "SV650",
            "SV650S",
            "SV650S1",
            "SV1000",
            "TL1000",
            "TU250X",
            "VL250",
            "VL250 INTRUDER",
            "VL800",
            "VL1500 BOULEVARD",
            "VL1500 INTRUDER",
            "VLR1800",
            "VZ800",
            "VZ1500",
            "VZR1800"
        ],
        "SYM" : [
            "125"
        ],
        "TAIWAN GOLDEN BEE" : [
            "101R",
            "101S",
            "303RS",
            "AKROS",
            "BULLET",
            "DELIVERY 125",
            "R50X",
            "TAPO"
        ],
        "TGB" : [
            "R50X"
        ],
        "TRIUMPH" : [
            "675 DAYTONA",
            "900 THUNDERBIRD",
            "AMERICA",
            "BONNEVILLE",
            "DAYTONA",
            "ROCKET III",
            "SCRAMBLER",
            "SPEEDMASTER",
            "SPEED TRIPLE",
            "SPRINT",
            "SPRINT 900/955",
            "SPRINT RS",
            "SPRINT ST",
            "STREET TRIPLE 675",
            "T100 BONNEVILLE",
            "T120 BONNEVILLE 650",
            "T900 BONNEVILLE",
            "THRUXTON",
            "THUNDERBIRD",
            "TIGER",
            "TIGER 800",
            "TIGER EXPLORER",
            "TRIDENT",
            "TROPHY 650",
            "TT600"
        ],
        "ULTRA" : [
            "GROUNDPOUNDER"
        ],
        "VESPA" : [
            "ET2",
            "GRANTOURISMO",
            "GTS 250",
            "GTS 300",
            "LX 50",
            "LX 125",
            "LX 150",
            "PX200E",
            "S 50"
        ],
        "VICTORY" : [
            "JUDGE"
        ],
        "VMOTO" : [
            "JP50",
            "JR125 - MONACO",
            "JX50",
            "MONZA"
        ],
        "YAMAHA" : [
            "AEROX 50",
            "BEEWEE",
            "CV50",
            "CW50",
            "CY50",
            "DT175",
            "DT200 ROAD/TRAIL",
            "FJ1200",
            "FJR1300",
            "FJR1300A",
            "FZ1-N",
            "FZ1-S",
            "FZ6-N",
            "FZ6-NHG",
            "FZ6-S",
            "FZ6-SHG",
            "FZ8-N",
            "FZI 1000",
            "FZR250",
            "FZS1000",
            "FZX250",
            "MT03",
            "MT07",
            "MT09",
            "MT-01",
            "NXC125 CYGNUS",
            "SCORPIO SERIES",
            "SR500 ROAD",
            "TDM850",
            "TDM900",
            "TRX850 ROAD",
            "TT250",
            "TT250R",
            "TT350",
            "TT600",
            "TTR230",
            "VIRAGO",
            "VMX1200 V-MAX",
            "V-MAX",
            "WR250",
            "WR250F",
            "WR250R",
            "WR400F",
            "WR426",
            "WR450F",
            "XC50 VINO",
            "XJ6FL",
            "XJ6NL",
            "XJ600",
            "XJ900",
            "XJ900S",
            "XJR1300",
            "XP500 T-MAX",
            "XS650 ROAD",
            "XT225",
            "XT250",
            "XT500",
            "XT600",
            "XT660R",
            "XT660Z",
            "XT1200Z",
            "XTZ660",
            "XV110",
            "XV250",
            "XV535 VIRAGO",
            "XV750",
            "XV1000 ROAD",
            "XV1100",
            "XV1600",
            "XV1700",
            "XV1900A",
            "XVS250",
            "XVS650",
            "XVS650A",
            "XVS650 V-STAR CLASSI",
            "XVS950A",
            "XVS1100",
            "XVS1100A",
            "XVS1100S",
            "XVS1300A",
            "XVZ1300",
            "YP250",
            "YP400",
            "YW100",
            "YZF600R",
            "YZF1000R",
            "YZFR15",
            "YZF-R1",
            "YZF-R6",
            "YZF-R 150"
        ]
    };

    var truckTypes = {
        "BEDFORD" : [
            "TK"
        ],
        "FUSO" : [
            "CANTER"
        ],
        "HINO" : [
            "300"
        ],
        "ISUZU" : [
            "NPR-200",
            "NPR-250",
            "NPR-400",
            "NPS-300"
        ],
        "IVECO" : [
            "TRAKKER"
        ],
        "KENWORTH" : [
            "K200"
        ],
        "KIA" : [
            "K2700"
        ],
        "MACK" : [
            "TRIDENT"
        ],
        "MAZDA" : [
            "T4600"
        ],
        "MERCEDES BENZ" : [
            "2434"
        ],
        "MITSUBISHI" : [
            "CANTER",
            "FUSO"
        ],
        "NISSAN" : [
            "ATLAS",
            "MK6"
        ],
        "SCANIA" : [
            "R"
        ],
        "TOYOTA" : [
            "DYNA"
        ],
        "VOLVO" : [
            "FE"
        ],
        "WESTERN STAR" : [
            "4800"
        ]
    };

    var bikes = {
        makes:  _.keys(bikeTypes),
        models: bikeTypes,
    };

    var cars = {
        makes:  _.keys(carTypes),
        models: carTypes,
    };

    var trucks = {
        makes:  _.keys(truckTypes),
        models: truckTypes,
    };

    function vt(id, text, extra = { data: { } }) {
        if (id === 'other') {
            extra.hasOther = true;
        }
        return _.extend(extra, { id: id, text: text });
    }

    self.vehicleTypeOptions = [
        vt('car',           'Passenger vehicle',    { data: cars    }),
        vt('motorcycle',    'Motorcycle / scooter', { data: bikes   }),
        vt('van',           'Ute / van',            { data: cars    }),
        vt('truck',         'Truck',                { data: trucks  }),
        vt('other',         'Other vehicle type'),
    ];

    self.make = { other: [ ] };
    self.model = { };
    _.each(self.vehicleTypeOptions, vt => {
        self.make[vt.id]  = vt.data.makes;
        self.model[vt.id] = vt.data.models;

        delete vt.data;
    });

    let thisYear = (new Date()).getFullYear();
    self.years = _.map(_.range(1970, thisYear+1).reverse(), y => y.toString());

    function opt(id, text) {
        return { id: id, text: text };
    }

    self.fuelTypeOptions = [
        opt('petrol',   'Petrol'),
        opt('diesel',   'Diesel'),
        opt('lpg',      'LPG'),
        opt('electric', 'Electric'),
        opt('hybrid',   'Hybrid'),
    ];
});

// This file was auto-generated. Do not hand edit.
